export default function CsharpInheritance() {
  return (
    <h2>Csharp Inheritance</h2>
  );
}
